export function getCurrentUser() {
  try {
    const raw = localStorage.getItem('admin_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isInfluencerUser() {
  const user = getCurrentUser();
  if (!user) return false;
  return user.is_influencer === true || user.user_type === 'influencer';
}
